
/**
 * GSC ANALYSIS INVARIANTS - V1.0
 * Authority: Senior Reliability Engineer
 */
export const ANALYSIS_INVARIANTS = {
  SAME_AUDIO_SAME_PARAMS_SAME_SCORE: true,
  ENVIRONMENT_DEPENDENCE: 'FORBIDDEN',
  FLOATING_POINT_TOLERANCE: 0.0001,
} as const;

export type AnalysisInvariants = typeof ANALYSIS_INVARIANTS;
